import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import Button from '~/components/Button';

import { CONTENT_SEARCH_LIMIT } from '../ContentSearchPickerModal.constants';

export interface IContentSearchPickerModalHeaderProps {
  isDisabled: boolean;
  isLoading: boolean;
  name: string;
  onCancel: () => void;
  onSave: () => void;
}

export const ContentSearchPickerModalHeader: React.FC<
  IContentSearchPickerModalHeaderProps
> = ({ isDisabled, isLoading, name, onCancel, onSave }) => {
  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      flexWrap="wrap"
      alignItems={{ base: 'inherit', md: 'center' }}
      marginY={6}
    >
      <Flex flex={1} alignItems="center">
        <Heading fontSize="3xl" margin={0} marginRight={1}>
          Selected content for {name}
        </Heading>
        <Text color="primary.300" fontSize="md" margin={0}>
          (Maximum of {CONTENT_SEARCH_LIMIT})
        </Text>
      </Flex>

      <Box
        marginTop={{ base: 2, md: 0 }}
        marginLeft={{ base: 'inherit', md: 'auto' }}
      >
        <Button onClick={onCancel} isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          colorScheme="primary"
          isDisabled={isDisabled}
          isLoading={isLoading}
          marginLeft={2}
          onClick={onSave}
          textTransform="none"
          track-id="foam-myagency-stackview-edit-content-save"
        >
          Save changes
        </Button>
      </Box>
    </Flex>
  );
};
